import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { APIObserverService } from '../../_observerServices/API-Observer';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';

@Component({
  selector: 'app-header-obv',
  templateUrl: './header-obv.component.html',
  styleUrls: ['./header-obv.component.css']
})
export class HeaderObvComponent implements OnInit {

  maxDate: Date = new Date();

  fileDownload: any = [];
  bookmarkArray: any = [""];

  dataSubject = new BehaviorSubject<any[]>([]);
  displayedColumns: string[] = ['Header', 'EntityName', 'Category', 'HeaderType', 'ApprovedDate', 'Contact'];
  //displayedColumns: string[] = ['Header', 'Category', 'ApprovedDate', 'HeaderType', 'EntityName', 'Contact'];
  /*  'Uploaded By', */
  form1: any = {};
  fetchedData: any;
  data: any = {};
  noRecord: any;
  bookmark: any = "";
  pageIndex: number = 1;
  fdate: any;
  ldate: any;
  filterType: string = "all";
  param: any;
  operation: string = "default";
  counts: any;
  floredvalue: number;
  textField: string;
  onSubmitFilter(filterForm) {
    this.bookmark = ""
    this.bookmarkArray = [""];
    this.operation = "search";
    this.pageIndex = 1;
    this.fdate = filterForm.startDate;
    this.ldate = filterForm.endDate;

    var cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US');

    if (typeof this.fdate === 'undefined' || this.fdate == null)
      this.fdate = "";
    else
      this.fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US');
    if (typeof this.ldate === 'undefined' || this.ldate == null)
      this.ldate = "";
    else
      this.ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US');

    if (filterForm.searchBy == "Category")
      this.param = filterForm.searchBy2
    else
      this.param = filterForm.search

      if((filterForm.searchBy == null || filterForm.searchBy == undefined)&&(this.param != undefined || this.param != null)){
        this.$modal.errorModal({
          title: 'Header Search',
          msg: 'Please select search by'
        });
        return;
      }

    if (typeof this.param === 'undefined' || this.param == null)
      this.param = "";



    if (filterForm.searchBy)
      this.filterType = filterForm.searchBy;
    if (this.fdate != "" && this.ldate == "") {
      this.ldate = cdate
    }


    if ((!filterForm.endDate && !filterForm.search && !filterForm.searchBy && !filterForm.startDate) || filterForm.searchBy == "" && !filterForm.startDate) {
      this.$modal.errorModal({
        title: 'Header Worklist',
        msg: 'Please search by valid criteria'
      });
    }
    else if ((this.filterType != null && this.filterType != "" && this.filterType != "all") && (this.param == null || this.param == "")) {
console.log("this.filtertyoe",this.filterType,this.param,this.operation)
      this.$modal.errorModal({
        title: 'Header Worklist',
        msg: 'Please provide ' + this.textField + ' value'
      });
    }
    else if (this.fdate == "" && this.ldate == "" && (this.filterType == null || this.filterType == "") && this.param == "") {
      this.$modal.errorModal({
        title: 'Header Worklist',
        msg: 'Please select any option'
      });
    }
    else if (this.fdate > this.ldate) {
      this.$modal.errorModal({
        title: 'Header Worklist',
        msg: 'From Date cannot be after To Date'
      });
    }
    else if (this.fdate == "" && this.ldate != "") {
      this.$modal.errorModal({
        title: 'Header Report',
        msg: 'Please select Start date'
      });
    }
    else {
      this.searchFunction()
    }
  }


  searchFunction() {
  if(this.filterType =="all"){
  this.filterType = ""
  }
	  console.log("this.bookmark search ",this.bookmark,this.filterType);
    this.data = {

      "Start_Date": this.fdate,
      "End_Date": this.ldate,
      "filterBy": this.filterType,
      "bookMark": this.bookmark,
      "size": "10",
      "data": this.param
    }
    this.obv.filterObserverData(this.data)
      .subscribe(r => {
        this.bookmark = r.bookmark
        this.counts = r.count
        this.floredvalue = Math.ceil(this.counts / 10)
        this.dataSource = r.Result;
        this.onChangeDataSource(r.Result);
      });
  }
  onChangeDataSource(value) {
    this.dataSubject.next(value);
    this.dataSource = new MatTableDataSource();

    this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator;
    //  this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));

    console.log("dataSource : ", this.dataSource);
  }

  public Entity_ID: any;
  applyFilter(filterValue: string) {
    console.log("in filter");
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  dataSource: any;

  form: any = {};
  showDropdown: boolean = false



  startDate1: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private obv: APIObserverService,
    private db: $DBManagerService,
    private fb: FormBuilder,
    private $modal: $ModalManagerService,
  ) {


  }

  ngOnInit() {


    this.APIgetHeaderSummary("");
    // this.dataSource.sort = this.sort;

    console.log(this.startDate1)
    this.maxDate.setDate(new Date().getDate());

  }
  APIgetHeaderSummary(bookmark) {

    var data = {
      'bookMark': bookmark
    }
	console.log("this.bookmark ",bookmark);
    this.obv.ObserverHeader(data).subscribe({
      next: value => {
        this.counts = value.count
        this.floredvalue = Math.ceil(this.counts / 10)
        this.dataSubject.next(value);
        this.bookmark = value.bookmark
        this.dataSource = new MatTableDataSource(value.Result);
        this.dataSource.sort = this.sort;
        console.log("dataSource : ", this.dataSource);

      }
    });
  }
  previous() {
    this.pageIndex--;
	console.log("this.pageIndex ",this.pageIndex);
	console.log("this.bookmark  prev ",this.bookmarkArray[this.pageIndex]);
	console.log("this.bookmarkArray ",this.bookmarkArray);
    if (this.pageIndex == 0) { 
      this.pageIndex++
      return;
    }
    if (this.operation == "default"){
		//-1
		console.log("this.default ");
      this.APIgetHeaderSummary(this.bookmarkArray[this.pageIndex])
	}
    else if (this.operation == "search"){
		console.log("thiseacr ");
		//this.bookmarkArray[this.pageIndex]
		this.bookmark = this.bookmarkArray[this.pageIndex-1]
      this.searchFunction()
	}
  }
  next() {
    this.bookmarkArray.push(this.bookmark)
    this.pageIndex++
    console.log("this.bookmark  next ",this.bookmark);
    if (this.operation == "default")
      this.APIgetHeaderSummary(this.bookmark)
    else if (this.operation == "search")
      this.searchFunction()
  }
  downloadentityworklistcsvfile() {
    this.data = {

      "Start_Date": this.fdate,
      "End_Date": this.ldate,
      "filterBy": this.filterType,
      "bookMark": "",
      // "size":"100000",
      "data": this.param
    }
    let now = new Date();
    var fileName;
    const currentdat = formatDate(now, 'medium', 'en-US', '+0530');
    this.obv.ObserverHeaderDownload(this.data).subscribe(r => {
      fileName = currentdat + '_Active Header.csv';
      importedSaveAs(r, fileName)
      //  this.downloadFile(r, Batch_Id);
      this.$modal.successModal({
        title: 'Header Summary',
        msg: 'File has been downloaded Successfully'
      });
    })

  }




  onApplyFilter1(filterForm1) {
    console.log(filterForm1.value);
  }
  reset() {
    this.pageIndex = 1
    this.data = {}
    this.APIgetHeaderSummary("");
    this.operation = "search";
	this.filterType="all";
    this.textField = "";
    this.showDropdown = false;
    this.fdate = null
    this.ldate = null

  }
  openDropdown(value) {
    this.form1.searchBy2 = null

    this.form1.search = null
    if(value=="EntityName")
    this.textField = "Entity Name"
    else if(value=="Header")
    this.textField = "Header"
    else if(value=="Category")
    this.textField = "Category"
    console.log("value", value)
    this.form1.searchBy2 = "";
    if (value == "Category") {
      this.showDropdown = true;
    }

    else {
      this.showDropdown = false;
    }
    this.form1.search = "";
  }


}
export class MyDataSource extends DataSource<any[]> {

  constructor(private subject: BehaviorSubject<any[]>) {
    super();
  }
  connect(): Observable<any[]> {
    return this.subject.asObservable();
  }
  disconnect(): void {

  }

}


